<template>
	<div class="game-wrapper trivial-wrapper stack-vertical relative" data-align="center">
		<div class="game-counters stack-horizontal" data-justify="spaced" data-align="center">
			<p>{{indexQuery+1}} / {{localGameContents.length}}</p>
			<p>{{timerDuration - timerCountSeconds}} s</p>
		</div>
		<div v-if="showOnlyIntro" class="quote-game-board-cont trivial-intro stack-vertical" data-align="center">
			<div class="quote-game-board game-intro-section stack-vertical small-radius relative">
				<p class="font-paragrafo-scrolly">{{$t('game_descrizione_trivial')}}</p>
			</div>
		</div>
		<base-button v-if="showOnlyIntro" type="variant4" :fit-width="isMobile" :text="utils.capitalizeFirst($t('game_inizia'))" @clicked="() => showOnlyIntro = false"/>
		<!-- ACTUAL GAME -->
		<div v-if="!showOnlyIntro" data-align="center" class="quote-game-cont trivial-game stack-vertical relative" data-justify="center">
			<base-button-rounded v-if="false" icon="back_arrow" :inactive="!showBackBtn" class="move-question go-back-question" color="var(--color-white)" icon-color="'var(--color-black)'" @button-clicked="manageNavigation('backward')"/>
			<base-button-rounded v-if="false" icon="back_arrow" :inactive="!showForwardBtn" class="move-question go-forward-question" color="var(--color-white)" icon-color="'var(--color-black)'" @button-clicked="manageNavigation('forward')" />
			<div class="game-quiz-questions abs-fill small-rounded">
				<div v-for="(q, i) in localGameContents"	:class="`game-trivial-question-cont stack-vertical small-rounded game-quiz-style-${q.styleId}`">
					<div v-if="indexQuery == i" :class="`game-result-modal game-over abs-fill stack-vertical small-rounded ${gameOver ? 'visible' : ''}`" data-justify="center" data-align="center">
						<div class="game-over-modal-contents stack-vertical" data-justify="spaced" data-align="center">
							<div class="stack-horizontal result-parenthesis game-over" data-align="center">
								<base-icon name="left-parenthesis"/>
								<div class="section-button-text stack-vertical" data-align="center">
									<h3 class="capitalize-first">{{gameOverText[$i18n.locale]}}</h3>
								</div>
								<base-icon name="right-parenthesis"/>
							</div>
							<h3 class="trivial-game-result-text capitalize-first">{{numQuestionsSolvedText[$i18n.locale]}}</h3>
							<h3 class="trivial-game-result-nums capitalize-first">{{numQuestionsSolved}} / {{localGameContents.length}}</h3>
						</div>
					</div>
					<div v-if="indexQuery == i" :class="`game-result-modal question-modal abs-fill stack-vertical small-rounded ${showResultModal ? 'visible' : ''}`" data-justify="center" data-align="center">
						<div v-if="result" class="stack-horizontal result-parenthesis good-result" data-align="center">
							<base-icon name="left-parenthesis"/>
							<div class="section-button-text stack-vertical" data-align="center">
								<h3 class="capitalize-first">{{resultText}}</h3>
							</div>
							<base-icon name="right-parenthesis"/>
						</div>
						<div v-else class="stack-vertical result-parenthesis wrong-result" data-align="center">
							<base-icon name="top-parenthesis"/>
							<div class="section-button-text stack-vertical" data-align="center">
								<h3 class="capitalize-first">{{resultText}}</h3>
							</div>
							<base-icon name="bottom-parenthesis"/>
						</div>
						<div class="full-answer-text font-paragrafo full-width">{{localGameContents[indexQuery].fullAnswer[$i18n.locale]}}</div>
						<!-- <div class="full-answer-text font-paragrafo full-width">{{q.fullAnswer[$i18n.locale]}}</div> -->
					</div>
					<div class="game-quiz-quote-text font-paragrafo-scrolly capitalize-first">{{q.fullQuery[$i18n.locale]}}</div>
					<div class="game-quiz-answers-cont stack-vertical">
						<button v-for="answer in q.answers" :class="{selected: answer.selected, 'wrong-answer': answer.selected && !answer.correct}" class="game-quiz-answer small-radius font-paragrafo capitalize-first" @click="chooseAnswer($event, answer.id)">{{answer.text[$i18n.locale]}}</button>
					</div>
				</div>
			</div>
		</div>
		<div class="relative">
			<Transition name="opacity-appear">
				<base-button v-if="showProceedBtn" class="go-next-question-btn" type="variant4" :fit-width="isMobile" :text="utils.capitalizeFirst(nextQueryText[$i18n.locale])" @clicked="performMoveQuestionsAfterResult" />
			</Transition>
			<base-button v-if="!showOnlyIntro" type="variant4" :disabled="!showTryAgainBtn" class="game-restart-btn" :fit-width="isMobile" :text="utils.capitalizeFirst(tryAgainText[$i18n.locale])" @clicked="resetGame" />
		</div>
	</div>
</template>

<script type="text/javascript">
	
import cloneDeep from 'lodash.clonedeep';
import remove from 'lodash.remove';
import shuffle from 'lodash.shuffle';
import { documentToSVG, elementToSVG, inlineResources, formatXML } from 'dom-to-svg';
import { nextTick, Transition } from 'vue';
import utils from '@js/utils.js';
import { mapGetters } from 'vuex';

export default {
	name: 'InterfaceQuoteGame',
	props: {
		gameContents: {
			type: Array,
			default: []
		},
		title: {
			type: String,
		},
		description:{
			type: String,
		}
	},
	data() {
		return {
			localGameContents: [],
			utils,
			showResultModal: false,
			gameOver: false,
			showProceedBtn: false,
			showOnlyIntro: true,
			showTryAgainBtn: false,
			canInteract: true,
			introButtonText: {
				it: 'inizia',
				en: 'start'
			},
			nextButtontext: {
				it: "prossima",
				en: "next",
			},
			sendButtonText: {
				it: "invia",
				en: "send"
			},
			shareButtonText: {
		 		it: "condividi",
				en: "share"
			},
			chooseWordButtonText: {
				it: "scegli parola",
				en: "choose word"
			},
			guessedQuoteOwner: '',
			completeQuoteText: {
				it: 'completa la citazione',
				en: 'complete the quote'
			},
			tryAgainText: {
				it: "riprova",
				en: "try again"
			},
			nextQueryText: {
				it: "prossima domanda",
				en: "next question"
			},
			gameOverText: {
				it: "complimenti",
				en: "congratulations"
			},
			badGameOverText: {
				it: "tempo scaduto",
				en: "game over"
			},
			timeIsOverText: {
				it: "tempo scaduto",
				en: "time is up"
			},
			numQuestionsSolvedText: {
				it: "ecco il tuo punteggio",
				en: "here's your score",
			},
			indexQuery: 0,
			result: false,
			goodResultWidth: 0,
			badResultHeight: 0,
			gameOverWidth: 0,
			timerStatus: 'working',
			timerDuration: 90,
			timerStart: 0,
			timerCountSeconds: 0,
			timerCountMilliseconds: 0
		}
	},
	computed: {
		...mapGetters(['isMobile']),
		currentQuery() {
			return this.localGameContents[this.indexQuery]
		},
		resultText() {
			return this.result ? this.$t('game_corretto') : this.$t('game_sbagliato') 
		},
		btnProceedText() {
			return this.result ? this.nextQueryText[this.$i18n.locale] : this.tryAgainText[this.$i18n.locale]
		},
		showBackBtn() {
			return this.indexQuery > 0;
		},
		showForwardBtn() {
			return this.indexQuery <= this.localGameContents.filter(el => el.resolved).length-1;
		},
		numQuestionsSolved() {
			return this.localGameContents.filter(q => q.resolvedForCounter).length
		}
	},
	watch: {
		async showOnlyIntro(n, o) {
			if(!n && o) {
				await nextTick();

				if(!this.isMobile) this.fixCssVarForDesktopAnswerAnimation()

				this.preliminaryOperationsOnAnimations();
				this.startAndManageTimer();
			}
		}
	},
	methods: {
		async chooseAnswer(e, id) {
			if(this.localGameContents[this.indexQuery].resolved || !this.canInteract) return

			e.stopPropagation();
			this.localGameContents[this.indexQuery].answers.find(a => a.id == id).selected = true
			this.canInteract = false;
			await nextTick();
			await new Promise(resolve => setTimeout(resolve, 200));
			this.checkAnswer(id);
		},
		async checkAnswer(id) {
			this.showResultModal = true;
			let firstCheck = this.localGameContents[this.indexQuery].answers.find(a => a.id == id).correct;
			if(firstCheck) {
				this.localGameContents[this.indexQuery].resolved = true
				this.localGameContents[this.indexQuery].resolvedForCounter = true
			}else if(this.currentQuery.answers.filter(el => el.selected).length == 3) { // what to do if i choose the wrong answer and the only one that remains is the right one
				// firstCheck = true
				// this.localGameContents[this.indexQuery].answers.find(a => a.correct).selected = true
				// await nextTick();
			}

			this.result = firstCheck;

			if(this.result && !this.localGameContents[this.indexQuery].showedFullAnswer) {
				this.timerStatus = 'paused'
			}

			await nextTick();
			await this.animateAnswer()
			// await new Promise(resolve => setTimeout(resolve, 1000));
			if(this.indexQuery < this.localGameContents.length-1 || (!this.result && this.indexQuery == this.localGameContents.length-1)) { // go to next question
				if((this.timerDuration*1000) - this.timerCountMilliseconds > 1000) {
					if(this.result && !this.localGameContents[this.indexQuery].showedFullAnswer) {
						this.showProceedBtn = true
						this.localGameContents[this.indexQuery].showedFullAnswer = true;
					}else {
						this.performMoveQuestionsAfterResult();
					}
				}
			}else if(this.result){ // GAME OVER
				// console.log('GAME OVER')
				this.manageResultModalDisappear();
				this.timerStatus = 'paused'
				this.gameOver = true;
				await nextTick();
				this.canInteract = false;
				await this.animateGameOver();
				this.showTryAgainBtn = true;
				// await this.disappearGoodResultModal();
			}
		},
		async performMoveQuestionsAfterResult() {
			this.timerStatus = 'working'
			this.startAndManageTimer(this.getDocumentTime() - Math.round(this.timerCountMilliseconds/1000)*1000);
			this.showResultModal = false
			this.showProceedBtn = false
			this.manageResultModalDisappear();
			this.moveQuestionsAfterResult();
		},
		async moveQuestionsAfterResult() {
			if(this.result) {
				await this.moveQuestion('forward')
			}else {
				await this.startFromBeginning();
			}
			this.canInteract = true;
		},
		async animateAnswer() {
			let t = utils.createTimeline(0.5, {});
			if(this.result) {
				document.querySelector('.result-parenthesis.good-result .section-button-text').style.width = 0;
				document.querySelector('.full-answer-text').style.opacity = 0;
				t.to('.result-parenthesis.good-result', {transform: 'translateY(0)', duration: 0}, 0)
				this.$el.querySelector('.game-result-modal.question-modal').style.zIndex = 2;
				t.to('.result-parenthesis.good-result .section-button-text', {width: this.goodResultWidth +'px', opacity: 1}, 0.5);
				if(!this.localGameContents[this.indexQuery].showedFullAnswer) {
					t.to('.result-parenthesis.good-result', {transform: 'translateY(calc(var(--middle-section-height) / 4 * -1))'}, 1)
					t.to('.full-answer-text', {opacity: 1}, 1.5)
				}
			}else {
				document.querySelector('.result-parenthesis.wrong-result .section-button-text').style.height = 0;
				this.$el.querySelector('.game-result-modal.question-modal').style.zIndex = 2;
				t.to('.full-answer-text', {opacity: 0, duration: 0}, 0)
				t.to('.result-parenthesis.wrong-result .section-button-text', {height: this.badResultHeight+'px', opacity: 1}, 0.5);
			}
			t.play();
			return new Promise(resolve => t.eventCallback('onComplete', resolve))
		},
		async manageNavigation(direction) {
			if(!this.canInteract || this.gameOver) return

			await this.moveQuestion(direction)
			this.canInteract = true;
		},
		async moveQuestion(direction, force) {

			let scaleStyleIndex = arr => {
				let lastZeroPos = arr.lastIndexOf(0)
				if(lastZeroPos < arr.length-2) {
					let newArr = cloneDeep(arr)
					let counter = 1;
					arr.forEach((el, i) => {
						if(i < lastZeroPos+2) {
							newArr[i] = 0
						}else if(counter < 4) {
							newArr[i] = counter
							counter++;
						}
					})
					return newArr;
				}else {
					return arr
				}
			}

			let scaleBackStyleIndex = arr => {
				if(arr.lastIndexOf(0) > -1) {
					let lastZeroPos = arr.lastIndexOf(0)
					let newArr = cloneDeep(arr)
					let counter = 1;
					arr.forEach((el, i) => {
						if(i < lastZeroPos) {
							newArr[i] = 0
						}else if(counter < 4) {
							newArr[i] = counter
							counter++;
						}else {
							newArr[i] = 100
						}
					})
					return newArr;
				}else {
					return arr
				}
			}

			let nextStyle = []

			if(direction == 'forward') {
				nextStyle = scaleStyleIndex(this.localGameContents.map(gc => gc.styleId))
			}else {
				nextStyle = scaleBackStyleIndex(this.localGameContents.map(gc => gc.styleId))
			}
			let newOne = cloneDeep(this.localGameContents)
			this.localGameContents.forEach((question, i) => {
				newOne[i].styleId = nextStyle[i]
			})

			this.localGameContents = newOne;

			if((direction == 'forward' && this.indexQuery < this.localGameContents.length) ||
				(direction == 'backward' && this.indexQuery > 0)) {
				this.indexQuery = (direction == 'forward' ? this.indexQuery+1 : this.indexQuery-1) 
			}
			return await nextTick();
		},
		async startFromBeginning() {
			for(var q of this.localGameContents) {
				q.resolved = false;

				for(var a of q.answers) {
					if(this.indexQuery)	a.selected = false
				}
			}

			for(var x = this.indexQuery; x >=0; x--) {
				if(this.gameOver) return
				await this.moveQuestion('backward')
				await new Promise(resolve => setTimeout(resolve, 200))
			}
		},
		async disappearGoodResultModal()	{
			let t = utils.createTimeline(0.5, {});
			t.to('.result-parenthesis.good-result', {opacity: 0}, 0);
			// t.to('.full-answer-text', {opacity: 0}, 0);
			t.to('.machiavelli-img', {opacity: 0}, 0);
			t.play();
			return new Promise(resolve => t.eventCallback('onComplete', resolve))
		},	
		async animateGameOver() {
			let t = utils.createTimeline(1, {});
			document.querySelector('.result-parenthesis.game-over .section-button-text').style.width = 0;
			// this.showTryAgainBtn = true;
			await nextTick();
			this.$el.querySelector('.game-result-modal.game-over').style.zIndex = 10;
			t.to('.result-parenthesis.game-over .section-button-text', {width: this.gameOverWidth +'px', opacity: 1}, 0.5);
			t.to('.trivial-game-result-text', {opacity: 1}, 1);
			t.to('.trivial-game-result-nums', {opacity: 1}, 1.5);
			t.to('.game-restart-btn', {opacity: 1}, 2);
			t.play();
			return new Promise(resolve => t.eventCallback('onComplete', resolve))
		},
		exitGame() {
			this.resetGame();
			this.$emit('exit')
		},
		manageResultModalDisappear() {
			let me = this;
			let fun = function(e) {
				if(e.propertyName == 'opacity' && !me.showResultModal) {
					this.style.zIndex = -2
					me.canInteract = true
				}
			}
			this.$el.querySelector('.game-result-modal.question-modal').removeEventListener('transitionend', fun)
			this.$el.querySelector('.game-result-modal.question-modal').addEventListener('transitionend', fun)
		},
		async preliminaryOperationsOnAnimations() {
			if(this.goodResultWidth !== 0) return // if already set, don't do it again
			let me = this;
			// close result parenthesis when the modal end disappear
			this.$el.querySelector('.game-result-modal.question-modal').addEventListener('transitionend', function(e) {
				if(e.propertyName == 'opacity' && !me.showResultModal) this.style.zIndex = -2
			})
			// assing width and height parenthesis results's texts 
			this.badResultHeight = document.querySelector('.result-parenthesis.wrong-result h3').getBoundingClientRect().height
			this.result = true;
			await nextTick();
			this.goodResultWidth = document.querySelector('.result-parenthesis.good-result h3').getBoundingClientRect().width
			this.result = false
			await nextTick();

			this.gameOverWidth = document.querySelector('.result-parenthesis.game-over h3').getBoundingClientRect().width

			// inhibit propagation from modal to answers container
			this.$el.querySelector('.game-result-modal').removeEventListener('click', e => e.stopPropagation())
			this.$el.querySelector('.game-result-modal').addEventListener('click', e => e.stopPropagation())
			this.$el.querySelector('.game-result-modal').removeEventListener('touchstart', e => e.stopPropagation())
			this.$el.querySelector('.game-result-modal').addEventListener('touchstart', e => e.stopPropagation())
		},
		setGameContents() {
			this.localGameContents = cloneDeep(this.gameContents)
			this.localGameContents.forEach((gc, i) => {
				gc.resolved = false;
				gc.resolvedForCounter = false;
				if(i < 3) gc.styleId = i+1
				else gc.styleId = 100

				gc.answers = shuffle(gc.answers)
				gc.showedFullAnswer = false;
			})
		},
		// resetGame() {
		// 	this.showResultModal = false
		// 	this.showOnlyIntro = false
		// },
		resetGame() {
			this.showTryAgainBtn = false;
			this.showResultModal = false
			this.gameOver = false;
			this.timerCountSeconds = 0;
			this.timerStart = 0;
			this.indexQuery = 0;
			this.canInteract = true;
			this.timerStatus = 'working'
			// await nextTick();
			// document.querySelector('.game-restart-btn').style.opacity = 0;
			this.setGameContents();
			this.showOnlyIntro = true;
		},
		startGameTimer(callback) {


			let frame = time => {
				// console.log('timerStatus', this.timerStatus)
				if (this.timerStatus !== 'working') return;

				// console.log('working frame')

				callback(time);
				scheduleFrame(time);
			}

			let scheduleFrame = time => {
				let timerElapsed = time - this.timerStart;
				const roundedElapsed = Math.round(timerElapsed / 1000) * 1000;
				const targetNext = this.timerStart + roundedElapsed + 1000;
				const delay = targetNext -  Date.now();
				setTimeout(() => requestAnimationFrame(frame), delay);
			}

			scheduleFrame(this.timerStart);
		},
		startAndManageTimer(start) {
			// console.log('restart timer')
			this.timerStart = start ? start : this.getDocumentTime();

			this.startGameTimer(async time => {
				this.timerCountSeconds = Math.round(time/1000) - Math.round(this.timerStart/1000);
				this.timerCountMilliseconds = time - this.timerStart;
				if(this.timerCountSeconds == this.timerDuration) {
					this.timerStatus = 'time over'
					this.gameOver = true;
					await nextTick();
					this.canInteract = false;
					this.showTryAgainBtn = true;
					await this.animateGameOver();
				}
				// console.log('timer', this.timerCountSeconds)
			});
		},
		getDocumentTime() { return document.timeline ? document.timeline.currentTime : performance.now() },
		fixCssVarForDesktopAnswerAnimation() {
			document.querySelector('.trivial-game').style.setProperty('--middle-section-height', `${document.querySelector('.trivial-game').clientHeight}px`)
		}
	},
	mounted() {
		this.setGameContents();
		// this.localGameContents = shuffle(this.localGameContents)
	}
}

</script>

<style lang="scss" scoped>

	@import "@css/components/gameStyle.scss";

	// @import "@css/variables.scss";

	// @import '@css/views/ViewScrolly.scss';

</style>
